<!-- <app-fortface-loader></app-fortface-loader> -->
<app-image-capture [isSelf]="true"></app-image-capture>
